import React, { useEffect } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import FeesOverview from '../../components/SchoolFees/FeesOverview';
import RecentFeesTransactions from '../../components/SchoolFees/RecentFeesTransactions';
import FeesMetricCards from '../../components/SchoolFees/FeesMetricCards';
import PageTitle from '../../components/SchoolFees/PageTitle';
import FeesActions from '../../components/SchoolFees/FeesActions';
import { useCurrency } from '../../util/SystemVariables';
import BalanceStatistics from '../../components/SchoolFees/BillingCenter/BalanceStatistics';
import functions from '../../util/functions';
import ActivityLoader from '../../components/Common/ActivityLoader';
import { useSchoolTransactions } from '../../DataStore/FeesTransactionContext';
import BillingStructure from '../../components/SchoolFees/BillingCenter/BillingStructure';
import { useSchool } from '../../DataStore/SchoolContext';

const SchoolFeesDashboard = () => {
    const currency = useCurrency();
    const {getGrossBalanceRatio, grossBalanceRatio} = useSchoolTransactions();
    const {feesStructures, getFeesStructures} = useSchool();
    useEffect(()=>{
        getGrossBalanceRatio();
        getFeesStructures();
    }, [])
    return (
        <PageContainer>
            <MainContent>
                <PageTitle
                    title="School Fees"
                    description="Invoice students and track their payments"
                    iconClass="fa fa-handshake"
                    sticky
                />

                <div className="row mb-4">
                    <div className="col-lg-5">
                        <FeesOverview currency={currency} /> 
                    </div>
                    <div className='col-lg-3'>
                            {functions.isObject(grossBalanceRatio) ? (
                                <BalanceStatistics 
                                    totalBilled={grossBalanceRatio.current_billed*1}
                                    totalPaid={grossBalanceRatio.current_settled*1}
                                    grossBalance={grossBalanceRatio.gross_balance}
                                    currentBalance={grossBalanceRatio.calc_current_balance}
                                    defaulters={grossBalanceRatio.current_defaulters}
                                    currency={currency}
                        />
                    ) : (
                        <ActivityLoader />
                    )}
                    </div>
                   
                    <div className="col-lg-4">
                        <FeesMetricCards currency={currency} />

                    </div>
                </div>

                <div className="row">
                                           

                    <div className="col-lg-8">
                        <FeesActions />
                        <BillingStructure feesStructure={feesStructures}/>               
                    </div>
                     <div className="col-lg-4">
                        <RecentFeesTransactions />
                    </div>
                </div>
                
            </MainContent>
        </PageContainer>
    );
};

export default SchoolFeesDashboard;
